import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';
import Input from 'af-fields/Input';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn2, formSectionClassColumn4, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';
interface OwnProps {
	isDisabled: boolean;
}

type Props = OwnProps;

const PublicSafetySection: React.FC<Props> = (props) => {
	const { isDisabled } = props;
	const checkboxStyle = React.useMemo(() => [formSectionClassColumn2, styles['job-form__tab-content__form-section__row__centered-column']].join(' '), []);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Public Safety"
				tooltip="Public safety measures required for this job, addressing potential risks to vehicle traffic and pedestrian movement in and around the job site."
			/>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="vehicleTraffic"
						isDisabled={isDisabled}
						label="Vehicle Traffic"
						name={JobUpsertFM.getAttributeName('vehicleTraffic')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="vehicleTrafficDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('vehicleTrafficDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="pedestrianCrossing"
						isDisabled={isDisabled}
						label="Pedestrian Crossing"
						name={JobUpsertFM.getAttributeName('pedestrianCrossing')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="pedestrianCrossingDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('pedestrianCrossingDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(PublicSafetySection);
